import { getConfigService } from '@core/services/config';
import { lazyService } from '@core/services/lazy';
import { getLocalizationService } from '@core/services/translate';

import _BugNoteFacade from '@archipad/services/bugNote.facade';
import {
    BugService,
    PhaseManager,
    PhaseService,
    VisitTypeService,
} from '@archipad-js/archipad/entity-services';

export { PhaseManager } from '@archipad-js/archipad/entity-services';
export type { IPhaseManager } from '@archipad-js/archipad/entity-services';

// This singleton is evaluated at import time, before the DI container is loaded;
// resolve the container-backed services lazily on first use.
export default new PhaseManager(
    new VisitTypeService(),
    new BugService(),
    new PhaseService(),
    _BugNoteFacade,
    lazyService(getConfigService),
    lazyService(getLocalizationService),
);
